import { render, staticRenderFns } from "./NewPlans.vue?vue&type=template&id=b2ae4b62&scoped=true"
import script from "./NewPlans.vue?vue&type=script&lang=js"
export * from "./NewPlans.vue?vue&type=script&lang=js"
import style0 from "./NewPlans.vue?vue&type=style&index=0&id=b2ae4b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ae4b62",
  null
  
)

export default component.exports